import request from '@/utils/httpRequest'

// 青藤

// 获取用户(会员)分页列表
export function getUserList (params) {
  return request({
    url: `/user/listPage`,
    method: 'get',
    params
  })
}

// 修改用户(会员)
export function modifyUser (data) {
  return request({
    url: `/user/modify`,
    method: 'post',
    data
  })
}
// 删除用户(会员)
export function deleteUser (data) {
  return request({
    url: `/user/delete`,
    method: 'post',
    data
  })
}
// 添加用户(会员)
export function addUser (data) {
  return request({
    url: `/user/add`,
    method: 'post',
    data
  })
}
// 修改用户(会员)积分
export function modifyPoint (data) {
  return request({
    url: `/point/modifyPoint`,
    method: 'post',
    data
  })
}
// 用户(会员)积分详情分页列表
export function getPointPage (params) {
  return request({
    url: `/point/userPointPage`,
    method: 'get',
    params
  })
}
// 重置密码
export function resetPassword (data) {
  return request({
    url: `/sys/user/resetPassword`,
    method: 'post',
    data
  })
}
